import { StartLoadingActionPayload, UpdateAssetsActionPayload } from './rootReducerTypes';

// #region actions
export type AssetListActionTypes =
    UpdateAssetsAction
    | StartLoadingAssetsAction
    | FetchInitAssetsAction
    | SetCurrentPageAssetsAction
    | UpdateQueryAssetsAction
    | SetPageSizeAssetsAction
    | UpdateSortByAssetsAction
    | UpdateSearchAssetsAction

export const UPDATE_ASSETS = "UPDATE_ASSETS";
export interface UpdateAssetsAction {
    type: typeof UPDATE_ASSETS;
    updateAssetsActionPayload: UpdateAssetsActionPayload;
}

export const START_LOADING_ASSETS = "START_LOADING_ASSETS";
export interface StartLoadingAssetsAction {
    type: typeof START_LOADING_ASSETS;
    startLoadingActionPayload: StartLoadingActionPayload
}

export const FETCH_INIT_ASSETS = "FETCH_INIT_ASSETS";
export interface FetchInitAssetsAction {
    type: typeof FETCH_INIT_ASSETS;
}

export const SET_CURRENT_PAGE_ASSETS = "SET_CURRENT_PAGE_ASSETS";
export interface SetCurrentPageAssetsAction {
    type: typeof SET_CURRENT_PAGE_ASSETS;
    currentPage: number;
}
export const SET_PAGE_SIZE_ASSETS = "SET_PAGE_SIZE_ASSETS";
export interface SetPageSizeAssetsAction {
    type: typeof SET_PAGE_SIZE_ASSETS;
    pageSize: number;
}
export const UPDATE_QUERY_ASSETS = "UPDATE_QUERY_ASSETS";
export interface UpdateQueryAssetsAction {
    type: typeof UPDATE_QUERY_ASSETS;
    lastQuery: string;
}

export const UPDATE_SORTBY_ASSETS = "UPDATE_SORTBY_ASSETS";
export interface UpdateSortByAssetsAction {
    type: typeof UPDATE_SORTBY_ASSETS;
    sortBy: string;
}

export const UPDATE_SEARCH_ASSETS = "UPDATE_SEARCH_ASSETS";
export interface UpdateSearchAssetsAction {
    type: typeof UPDATE_SEARCH_ASSETS;
    searchText: string;
}

